(() => {
  const stores = {
    'amazon-usa': { name: 'Amazon US', country: 'usa', source: 'detail-a' },
    'amazon-uk': { name: 'Amazon UK', country: 'uk', source: 'detail-a' },
    'amazon-dubai': { name: 'Amazon UAE', country: 'dubai', source: 'detail-a' },
    taobao: { name: 'Taobao China', country: 'china', source: 'detail-b' },
    '1688': { name: '1688 China', country: 'china', source: 'detail-c' },
    walmart: { name: 'Walmart US', country: 'usa', prefix: 'walmart:' },
    shein: { name: 'SHEIN clothing', country: 'usa', prefix: 'shein:' }
  };
  const requestedStore = new URLSearchParams(location.search).get('store');
  const selected = Object.prototype.hasOwnProperty.call(stores, requestedStore) ? stores[requestedStore] : null;
  const countryMarket = location.pathname.match(/\/origin-(usa|uk|dubai|china)(?:\/|$)/)?.[1];
  const market = selected ? requestedStore : countryMarket;
  const grid = document.querySelector('[data-collection-grid]');
  if (!countryMarket || !grid || (!selected && (location.search.includes('filter.')))) return;
  if (selected) {
    grid.hidden = true;
    grid.style.display = 'none';
    const heading = document.querySelector('main h1');
    if (heading) heading.textContent = selected.name;
    document.querySelectorAll('main .pagination-wrapper, main .pagination').forEach(element => { element.hidden = true; element.style.display = 'none'; });
  }
  const endpoint = '/apps/salibay-search';
  const products = new Map();
  let visibleCount = 0;
  const supportedSorts = ['manual', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending'];
  let sortMode = new URLSearchParams(location.search).get('sort_by') || 'manual';
  if (!supportedSorts.includes(sortMode)) sortMode = 'manual';
  let page = 1;
  let busy = false;
  let fresh = false;
  let failed = false;
  const section = document.createElement('section');
  section.className = 'salibay-market-feed';
  section.innerHTML = '<h2>Shop international products</h2><p class="text-xs text-gray-500">Sorting applies to products currently loaded. Load more to expand the selection.</p><p role="status" data-market-status>Loading products...</p><div class="salibay-product-grid" data-market-grid></div><button type="button" class="btn-secondary" data-market-more>Load more products</button>';
  section.querySelector('h2').textContent = selected ? 'Shop ' + selected.name : `Shop products from ${{usa:'the US', uk:'the UK', dubai:'Dubai', china:'China'}[market]}`;
  grid.parentElement.insertBefore(section, grid);
  const target = section.querySelector('[data-market-grid]');
  const status = section.querySelector('[data-market-status]');
  const more = section.querySelector('[data-market-more]');
  const escape = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => `KES ${new Intl.NumberFormat('en-KE', {maximumFractionDigits:0}).format(value)}`;
  function enqueue(items,sourcePage=1) {
    for (const product of items) {
      if (selected?.prefix && !String(product.publicId || '').startsWith(selected.prefix)) continue;
      if (selected?.source && product.detailSource !== selected.source) continue;
      if (!product.publicId || !product.imageUrl || !Number.isFinite(product.price) || products.has(product.publicId)) continue;
      products.set(product.publicId, {...product,navigationMarket:market,navigationPage:sourcePage});
    }
  }
  function orderedProducts() {
    const items = [...products.values()];
    if (sortMode === 'title-ascending') items.sort((a,b) => a.title.localeCompare(b.title, 'en', {numeric:true, sensitivity:'base'}));
    if (sortMode === 'title-descending') items.sort((a,b) => b.title.localeCompare(a.title, 'en', {numeric:true, sensitivity:'base'}));
    if (sortMode === 'price-ascending') items.sort((a,b) => a.price - b.price);
    if (sortMode === 'price-descending') items.sort((a,b) => b.price - a.price);
    return items;
  }
  function paint() {
    target.replaceChildren();
    for (const product of orderedProducts().slice(0,visibleCount)) {
      const card = window.SalibayProductCards.create(product,{market,page:product.navigationPage});
      card.classList.add('market-product-card');
      card.dataset.marketProduct=product.publicId;
      target.append(card);
    }
    more.hidden = visibleCount >= products.size && !page;
  }
  function render() {
    visibleCount = Math.min(products.size, visibleCount + 20);
    paint();
  }
  document.querySelectorAll('[data-collection-sort]').forEach(select => {
    const options = [['manual','Recommended'],['title-ascending','Alphabetically, A–Z'],['title-descending','Alphabetically, Z–A'],['price-ascending','Price, low to high'],['price-descending','Price, high to low']];
    select.replaceChildren(...options.map(([value,label]) => {
      const option = document.createElement('option');
      option.value = value; option.textContent = label;
      return option;
    }));
    select.value = sortMode;
    select.setAttribute('aria-label', 'Sort loaded products');
    const label = select.parentElement?.querySelector('label');
    if (label) label.textContent = 'Sort loaded products:';
  });
  window.addEventListener('salibay:market-sort', event => {
    if (!supportedSorts.includes(event.detail?.value)) return;
    sortMode = event.detail.value;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', sortMode);
    url.searchParams.delete('page');
    history.replaceState(null, '', url);
    document.querySelectorAll('[data-collection-sort]').forEach(select => {select.value = sortMode;});
    paint();
  });
  const cacheKey = `salibay-market:v6:${market}`;
  try {
    const saved = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
    if (saved && Date.now() - saved.savedAt < 21_600_000) {
      enqueue(saved.feed.products); render(); page = saved.feed.nextPage; fresh = true;
      status.textContent = 'Checking for new products...';
    }
  } catch (_) {}
  async function load(refresh = false) {
    if (busy || (!page && !refresh)) return;
    if (products.size > visibleCount && !refresh) {render(); return;}
    busy = true; failed = false; more.disabled = true; section.setAttribute('aria-busy','true');
    more.textContent = 'Loading products...';
    status.textContent = fresh ? 'Loading more products...' : 'Loading products...';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 45_000);
    try {
      const sourcePage=refresh ? 1 : page;
      const response = await fetch(`${endpoint}/discover?market=${market}&page=${sourcePage}`, {signal:controller.signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Marketplace unavailable');
      const feed = await response.json();
      if (!Array.isArray(feed.products) || !feed.products.length) throw new Error('No fresh products');
      if (refresh) {
        // Replace only after a complete fresh response, never while waiting.
        products.clear(); visibleCount = 0; target.replaceChildren();
        try {sessionStorage.setItem(cacheKey, JSON.stringify({savedAt:Date.now(), feed}));} catch (_) {}
      }
      enqueue(feed.products,sourcePage); page = feed.nextPage; fresh = true; render();
      more.textContent = 'Load more products';
      status.textContent = feed.selection === 'best-sellers' ? 'Shop popular best-selling products' : selected ? 'Explore relevant products from ' + selected.name : 'Explore more products from this country';
    } catch (_) {
      failed = true;
      status.textContent = selected ? selected.name + ' products are temporarily unavailable. Please try again.' : 'More products could not load. You can shop the products below or try again.';
      more.hidden = false; more.textContent = 'Try again';
      observer?.disconnect();
    } finally {
      clearTimeout(timeout); busy = false; more.disabled = false; section.removeAttribute('aria-busy');
      if (!failed && !more.hidden) { observer?.unobserve(more); observer?.observe(more); }
    }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting) && fresh) load();
  }, {rootMargin:'300px'}) : null;
  more.addEventListener('click', () => load());
  observer?.observe(more);
  load(true);
})();
